// src/utils/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import UnauthorizedPage from '../pages/UnauthorizedPage';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { currentUser, role, authReady } = useContext(AuthContext);

  if (!authReady) {
    // Authentication state is not ready yet
    return <div className="flex justify-center items-center min-h-screen">Loading...</div>;
  }

  if (!currentUser) {
    // User is not authenticated
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    // User does not have the required role
    return <UnauthorizedPage />;
  }

  // User is authenticated and has the required role
  return children;
};

export default ProtectedRoute;
